<template>
    <card>
        <template slot="header">
            <h4 class="card-title">Reparos<!--{{ $t("dashboard.repairscomplete_title") }}--></h4>

            <div>
              <p class="card-category text-muted">{{ $t("dashboard.repairsidleperperiodbyasf_subtitle") }}</p>
              <div class="row">
                <div class="col-md-4">
                  <multiselect
                    :value="asf_value"
                    @input="onAsfSelect"
                    :options="asfs"
                    :custom-label="asfLabel"
                    :placeholder="$t('text.select')"
                    label="name"
                    track-by="id"
                    class="b-form-btn-label-control"
                    @open="getAsfs"
                  ></multiselect>
                </div>

                <div class="col-md-4">
                  <a
                    @click.prevent="selectAllAsfs"
                    class="btn btn-primary px-2 rounded"
                    href
                  >{{$t('button.showAllAsfs')}}</a>
                </div>
              </div>

            </div>

        </template>
        <br />
        <div class="container py-4">
          <slot name="loading">
            <div v-if="!loaded" class="lds-container">
              <div class="lds-ring">
                <div></div><div></div><div></div><div></div>
              </div>
            </div>
          </slot>
          <bar v-if="loaded" :chartdata="chartdata" :options="options" style="height: 500px"></bar>
          <p v-if="loaded" class="text-muted small text-center mb-0">{{ $t("dashboard.idlerepairs_chart_hint") }}</p>
        </div>

        <!-- <div class="mt-2 h6" v-if="loaded">
            <slot v-for="(label, index) in chartdata.labels">
                <small class="mr-2 d-inline-block" :key="index">
                    <i class="fas fa-circle" :style="'color:'+colors.fill[index]"></i>
                    {{ label }}
                </small>
            </slot>
        </div> -->
    </card>
</template>

<script>
import { mapState } from "vuex";
import { Bar } from "@/components/index";
import $http from "@/helpers/api";
import { generateColors } from "@/helpers/filters";
import { IDLE_PERIODS } from "./idlePeriods";
export default {
  name: "RepairsIdlePerPeriodByASF",
  components: { Bar },
  computed: {
    ...mapState("asfs", {
      asfs: "all"
    }),
    asf() {
      return this.$store.getters["auth/getAsf"];
    },
    now() {
      return new Date();
    }
  },
  data: () => ({
    loaded: false,
    // Only this control changes its selection; table/summary filters never flow back here.
    asf_value: null,
    // Id of the latest request: changing filters quickly must not let an older response win
    latestRequest: 0,
    colors: [],
    statuses: [],
    periods: [],
    chartdata: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout:{
        padding:30
      },
      legend: {
        display: true,
        position: "bottom",
      },
      plugins: {
        // Every status gets a label at the end of its segment; empty segments all end at the
        // same spot and their "0" would be drawn over the real count, so they get none
        datalabels: {
          display: context => !!context.dataset.data[context.dataIndex]
        }
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            display: true
          }
        ],

        // And this will affect the horizontal lines (yAxe) of your dataset
        yAxes: [
          {
            stacked: true,
            ticks: {
                min: 0,
                stepSize: 1
            },
            gridLines: {
              drawBorder: false,
              borderDash: [3, 3]
            }
          }
        ]
      }
    }
  }),
  methods: {
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAllAsfs() {
      this.onAsfSelect(null);
    },
    onAsfSelect(asf) {
      this.asf_value = asf;
      this.$emit("change", { asf: asf ? asf.id : "" });
    },
    onBarClick(evt, elements) {
      const element = elements && elements[0];

      if (!element) {
        return;
      }

      const status = this.statuses[element._datasetIndex];
      const period = this.periods[element._index];

      if (!status || !period) {
        return;
      }

      this.$emit("select", {
        status_id: status.id,
        period: period.filter(value => value !== null).join(",")
      });
    },
    onBarHover(evt, elements) {
      evt.target.style.cursor = elements.length ? "pointer" : "default";
    },
    onLegendClick(evt, item) {
      const status = this.statuses[item.datasetIndex];
      if (status) {
        this.$emit("select", { status_id: status.id });
      }
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs", "name");
    },
    getData() {
      const request = ++this.latestRequest;

      this.loaded = false;
      $http.get("/stats/repairs/by_status", { params: { periods: IDLE_PERIODS } }).then(resp => {
        if (request !== this.latestRequest) {
          return;
        }

        let dataset = [];

        let data = Object.entries(resp.data.data);

        this.colors = {
          fill: generateColors(data.length, "B3"),
          border: generateColors(data.length)
        };

        let colori = 0;

        for (const item of data){
          dataset.push(
            {
              label: item[0],
              // null leaves empty segments out, so minBarLength only lifts the ones with repairs
              data: item[1].map(total => total || null),
              // Keeps a few repairs visible (and clickable) next to periods with hundreds
              minBarLength: 4,
              backgroundColor: this.colors.fill[colori],
              borderColor: this.colors.border[colori],
              borderWidth: "1",
              hoverBackgroundColor: this.colors.border[colori]
            }
            );
          colori++;

          };

        this.statuses = resp.data.statuses || [];
        this.periods = resp.data.periods || [];

        this.chartdata = {
          labels: resp.data.labels,
          datasets: dataset
        };

        this.loaded = true;
      });
    }
  },
  created() {
    this.options.onClick = this.onBarClick;
    // The legend is another table shortcut, rather than Chart.js's default hide/show action.
    this.options.legend.onClick = this.onLegendClick;
    // Bar charts default to hover mode "label", which hands onClick every stacked
    // segment of the column (bottom one first); "nearest" gives only the one under the cursor
    this.options.hover = { mode: "nearest", intersect: true, onHover: this.onBarHover };
  },
  mounted() {
    this.getData();
  }
};
</script>
